import { MoonLoader } from 'react-spinners';

const LoadingModal = ({ message = 'Processing your request...', error = null, onClose = null }) => {
  const errorMessage = error
    ? typeof error === 'string'
      ? error
      : error.message || 'An error occurred'
    : null;

  return (
    <div className="fixed inset-0 flex items-center justify-center z-50">
      <div className="absolute inset-0 bg-black bg-opacity-50 backdrop-blur-sm"></div>

      <div
        className={`bg-white rounded-lg shadow-xl p-6 m-4 max-w-sm w-full relative z-10 border-l-4 ${
          error ? 'border-red-600' : 'border-lime-700'
        }`}
      >
        {error && onClose && (
          <button
            onClick={onClose}
            className="absolute top-3 right-3 text-gray-500 hover:text-gray-700"
            aria-label="Close"
          >
            <svg
              xmlns="http://www.w3.org/2000/svg"
              className="h-6 w-6"
              fill="none"
              viewBox="0 0 24 24"
              stroke="currentColor"
            >
              <path
                strokeLinecap="round"
                strokeLinejoin="round"
                strokeWidth={2}
                d="M6 18L18 6M6 6l12 12"
              />
            </svg>
          </button>
        )}

        <div className="flex flex-col items-center">
          {!error ? (
            <MoonLoader size={60} color="#2E7A32" loading={true} speedMultiplier={0.75} />
          ) : (
            <div className="flex items-center justify-center w-16 h-16 rounded-full bg-red-100 mb-2">
              <svg
                xmlns="http://www.w3.org/2000/svg"
                className="h-10 w-10 text-red-600"
                fill="none"
                viewBox="0 0 24 24"
                stroke="currentColor"
              >
                <path
                  strokeLinecap="round"
                  strokeLinejoin="round"
                  strokeWidth={2}
                  d="M6 18L18 6M6 6l12 12"
                />
              </svg>
            </div>
          )}

          <p className={`mt-4 text-center font-medium ${error ? 'text-red-600' : 'text-gray-700'}`}>
            {error ? errorMessage : message}
          </p>

          {error && onClose && (
            <button
              onClick={onClose}
              className="mt-4 px-4 py-2 bg-red-600 text-white rounded-md hover:bg-red-700 transition-colors"
            >
              Dismiss
            </button>
          )}
        </div>
      </div>
    </div>
  );
};

export { LoadingModal };
